import React, { Component } from "react";
import Media from "src/components/Media";
import url from "url";

import getImageObject from "src/helpers/getImageObject";

import SectionLight from "src/components/Modules/SectionLight";
import PageStyles from "src/components/styles/PageStyles";
import ContentWrapper from "src/components/UI/Structure/ContentWrapper";
import Container from "src/components/UI/Grid/Container";
import Grid from "src/components/UI/Grid/Grid";
import Column from "src/components/UI/Grid/Column";
import Box from "src/components/UI/Structure/Box";
import Flex from "src/components/UI/Structure/Flex";
import Text from "src/components/UI/Text";
import SEO from "src/components/Modules/SEO";
import Hero from "src/components/Modules/Hero";
import Content from "src/components/Modules/Content";
import ArtistHighlightEvents from "src/components/Artist/ArtistHighlightEvents";
import Video from "src/components/Modules/Video";
import Release from "src/components/Modules/Release";
import LinkList from "src/components/Artist/LinkList";
import WorkAreas from "src/components/Artist/WorkAreas";
import Chapters from "src/components/Artist/Chapters";
import ArtistAgent from "src/components/Artist/ArtistAgent";
import RelatedArtists from "src/components/Artist/RelatedArtists";
import Icon from "src/components/UI/Icon";
import SpotifyIcon from "src/images/svg/icon-spotify.svg";

class ArtistTemplate extends Component {
  state = {
    haveEvents: true,
  };

  setHaveEvents = (value) => {
    if (value !== this.state.haveEvents) {
      this.setState({ haveEvents: value });
    }
  };

  render() {
    // Get page data
    const { previewData, gatsbyData } = this.props;
    const { haveEvents } = this.state;
    // Choose data based on gatsby or preview mode
    const artist = previewData ? previewData : gatsbyData;

    // Set page data
    const { title, featuredImage, link, acfArtistPage } = artist;

    const images = getImageObject(featuredImage);
    const {
      cta,
      country,
      introduction,
      video,
      release,
      chapters,
      links,
      agent,
      agentRole,
      workAreas,
      relatedArtists,
    } = acfArtistPage;

    const artists =
      relatedArtists?.artists?.length > 0
        ? relatedArtists.artists.map(({ artist }) => artist)
        : [];

    // CTA
    const ctaAction = cta.action || null;
    const ctaLink =
      ctaAction === "release"
        ? cta.link.url
        : ctaAction === "tour"
        ? `${link ? new URL(link).pathname : ""}konserter`
        : "";
    const ctaTitle =
      ctaAction === "release"
        ? cta.link.title
        : ctaAction === "tour"
        ? "Turné"
        : "";

    // SEO
    let seoDescription = "";
    if (introduction && introduction.preamble) {
      seoDescription = introduction.preamble.replace(/<\/?[^>]+(>|$)/g, "");

      if (seoDescription.length > 220) {
        seoDescription = seoDescription.slice(0, 220) + "...";
      }
    }
    return (
      <PageStyles>
        <SEO
          title={title}
          summary={seoDescription}
          description={seoDescription}
          ogImage={images}
        />
        <SectionLight sticky>
          <Hero
            headerColor="light"
            size="medium"
            title={title}
            titleExtra={country && country !== "none" ? `(${country})` : ""}
            largeHeadline
            images={images}
            link={ctaLink}
            linkTitle={ctaTitle}
            buttonLayout={{
              filled: "white",
              defaultStyle: 0,
            }}
            buttonContent={
              cta && ctaLink ? (
                <Flex
                  width={1}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Text fontSize={2} letterSpacing="0.75px" pr="2">
                    Aktuell med
                  </Text>
                  <Text
                    fontSize={2}
                    fontWeight="bold"
                    px="2"
                    letterSpacing="0.75px"
                  >
                    {ctaTitle}
                  </Text>
                  <Text fontSize={2} pl="2" fontWeight="bold">
                    {ctaAction === "release" ? (
                      <Icon size="small">
                        <SpotifyIcon />
                      </Icon>
                    ) : (
                      `→`
                    )}
                  </Text>
                </Flex>
              ) : null
            }
          />
        </SectionLight>
        <ContentWrapper>
          <Container>
            <Grid justifyContent="space-between">
              {/* Introduction */}
              {introduction && (
                <Column
                  width={
                    haveEvents
                      ? [12 / 12, null, 6 / 12, 5 / 12]
                      : [12 / 12, null, null, 7 / 12, 7 / 12]
                  }
                  order={[1, null, null, 0]}
                  mt={[0, null, null, 8]}
                  ml={[0, null, null, null, (1 / 12) * 100 + "%"]}
                  mb={[8, null, null, 15]}
                >
                  <Content
                    content={introduction.preamble}
                    title={introduction.headline}
                  />
                </Column>
              )}
              {/* Events */}
              <Column
                width={
                  haveEvents
                    ? [12 / 12, null, null, 6 / 12, 5 / 12]
                    : [12 / 12, null, null, 3 / 12, 3 / 12]
                }
                order={[0, null, null, 1]}
                mt={[0, null, null, "-115px", "-115px", "-130px"]}
                mb={[8, null, null, 15]}
              >
                <ArtistHighlightEvents
                  artist={artist}
                  setHaveEvents={this.setHaveEvents}
                  label="Kommande konserter"
                  readMoreText="Visa alla konserter"
                />
              </Column>
              {/* Video */}
              <Column
                width={[12 / 12, null, null, 6 / 12]}
                mb={[8, null, null, 15]}
              >
                {video?.use && (video.youtubeId || video.vimeoId) && (
                  <Box ml="-32px" mr={["-32px", null, null, 0]}>
                    <Video
                      images={getImageObject(video.image)}
                      youtubeId={
                        video.service === "youtube" ? video.youtubeId : null
                      }
                      vimeoId={video.service === "vimeo" ? video.vimeoId : null}
                    />
                  </Box>
                )}
              </Column>
              {/* Release (Desktop) */}
              {release?.use && (
                <Media
                  query="(min-width: 992px)"
                  render={() => (
                    <Column
                      width={[12 / 12, null, null, 5 / 12]}
                      mb={[8, null, null, 15]}
                    >
                      <Grid justifyContent="center" alignItems="center">
                        <Column width={[8 / 12, null, null, null, 6 / 12]}>
                          <Release label="Senaste release" release={release} />
                        </Column>
                      </Grid>
                    </Column>
                  )}
                />
              )}
            </Grid>
          </Container>
          {/* Chapters */}
          {chapters && (
            <Container>
              {chapters && <Chapters chapters={chapters} />}
            </Container>
          )}
          {/* Release (Mobile) */}
          {release && release.use && (
            <Media
              query="(max-width: 992px)"
              render={() => (
                <Container py="7" bg="#EAEAEA">
                  <Grid>
                    <Column
                      width={[12 / 12, null, null, 5 / 12]}
                      mb={[8, null, null, 15]}
                    >
                      <Grid justifyContent="center" alignItems="center">
                        <Column width={[8 / 12, null, null, null, 6 / 12]}>
                          <Release
                            label="Senaste release"
                            release={release}
                            buttonStyle="white"
                          />
                        </Column>
                      </Grid>
                    </Column>
                  </Grid>
                </Container>
              )}
            />
          )}
          <Container>
            {(links || agent) && (
              <Grid justifyContent="space-between" alignItems="center">
                {/* Links */}
                <Column
                  width={[12 / 12, null, null, 6 / 12]}
                  mb={[8, null, null, 15]}
                >
                  {links?.length > 0 && (
                    <Box
                      ml={["-32px", null, null, null, 0]}
                      mr={["-32px", null, null, null, 0]}
                      px={["32px", null, null, null, 0]}
                      py={[8, null, null, "160px"]}
                      bg="dark"
                    >
                      <Grid justifyContent="center">
                        <Column
                          width={[12 / 12, null, null, 10 / 12, 8 / 12]}
                          mb={0}
                        >
                          <LinkList links={links} light division="production" />
                        </Column>
                      </Grid>
                    </Box>
                  )}
                </Column>
                {/* Contact */}
                <Column
                  width={[12 / 12, null, null, 5 / 12]}
                  mb={[8, null, null, 15]}
                >
                  {agent && (
                    <Grid>
                      <Column
                        width={[12 / 12, null, 6 / 12, 7 / 12]}
                        mb={[5, null, null, null, 0]}
                      >
                        <ArtistAgent
                          agent={agent}
                          artist={title}
                          label="Kontakta oss"
                          customRole={agentRole}
                        />
                      </Column>
                      <Column width={[12 / 12, null, 6 / 12, 5 / 12]}>
                        {workAreas && (
                          <Box mb={4}>
                            <WorkAreas label="Vad vi gör" areas={workAreas} />
                          </Box>
                        )}
                      </Column>
                    </Grid>
                  )}
                </Column>
              </Grid>
            )}
          </Container>
          {/* Related artists */}
          {relatedArtists.use && artists && (
            <RelatedArtists
              label="Relaterade artister"
              relatedArtists={artists}
            />
          )}
        </ContentWrapper>
      </PageStyles>
    );
  }
}

export default ArtistTemplate;
